import { classNames } from "primereact/utils"
import { useAppSelector } from "../../../../../stateManagement/hooks/redux"
import MapFilters from "../filters/MapFilters"
import { mapFiltersConfig } from "./map.filters.config"

export default function WaysideLandLotsOverlay() {

    const filterMenuIsExpanded = useAppSelector(state => state.maps.waysideLandLots.filterMenuIsExpanded)

    let mapOverlayClassName = classNames({
        "map-overlay": true,
        "with-filters": true,
        "filters-div-opened": filterMenuIsExpanded
    })

    return (
        <>
            <div className={mapOverlayClassName}>
                <MapFilters filtersConfig={mapFiltersConfig} />
            </div>
        </>
    )
}
